import i18n from '@yandex-int/i18n';
import { Button } from 'lego-on-react';
import block from 'propmods';
import React, { FC, useEffect, useState } from 'react';
import * as keyset from 'i18n/News';
import { banNews, getLastNews } from '../../api';
import { truncateTitle } from '../../lib/utils';
import { NewsResponse } from '../../types';
import './NewsPreview.scss';

const b = block('NewsPreview');

const t = i18n(keyset);

const NewsPreview: FC = () => {
    const [news, setNews] = useState<NewsResponse | null>(null);
    const [showCnt, setShowCnt] = useState(false);

    const banNewsHandler = (id: string) =>
        banNews(id)
            .then(() => setShowCnt(false))
            .catch(console.error);

    const fetchNews = () =>
        void getLastNews()
            .then(setNews)
            .then(() => setShowCnt(true))
            .catch(console.error);

    useEffect(fetchNews, []);

    const showNews = news && news?.title && news?.url;

    return (
        <div {...b({ show: showCnt })}>
            {showNews ? (
                <div {...b('inner')}>
                    <div {...b('main')}>
                        <h3 {...b('news-title')}>{truncateTitle(news.title, 100)} </h3>
                        <Button theme="action" size="m" onClick={() => window.open(news.url)}>
                            {t('details')}
                        </Button>
                    </div>
                    <button {...b('close-btn')} title={t('hide')} onClick={() => banNewsHandler(news.id)}>
                        <span {...b('close-icon ')} />
                    </button>
                </div>
            ) : null}
        </div>
    );
};

export default NewsPreview;
